<template>
	<view @click="click(data.config.path)" style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		
		<div v-if="user" class="cardContainerItemView" v-bind:style="{background:data.config.containerBgColor ||''}">
			<!-- <div><img class="storePicture" :src="user.avatar" /></div>
			<div class="descContainer">
				<label class="labelItem"
					v-bind:style="{color:data.config.textColor ||''}">{{user.nick}}</label>
				<label class="labelItem addressLabel" v-bind:style="{color:data.config.addressColor ||''}"><i
						type="ios-navigate-outline" size="18" /> {{user.intro || ''}}</label>
			</div> -->
			<!-- <view size="mini" style="margin-left: 120px; color: darkgray; margin-top: 25px;">修改账号</view> -->
			
			<view style="display: flex; ">
				<view style="margin: 10px;"><img class="storePicture" :src="user.avatar" /></view>
				<view style="margin-top: 10px; margin-left: 20px; text-align: left;">
					<view class="labelItem"
					v-bind:style="{color:data.config.textColor ||''}" style="font-size: 22px;">{{user.nick}}</view>
					<view style="color: darkgray; margin-top: 5px;">{{user.phone}}</view>
				</view>
			</view>
		</div>
	</view>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
			user: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {
				
			}
		},
		methods: {
			click(path) {
				uni.navigateTo({
					url: path
				});

			},
		}
	};
</script>

<style scoped>
	.cardContainerItemView {
		text-align: center;
		width: 100%;
				/* display: flex; */
		background-color: white;
		padding: 0.625rem;
		box-sizing: border-box;
		border-radius: 0.25rem;
		overflow: hidden;
		/* text-align: center; */
	}


	.storePicture {
		height: 60px;
		width: 60px;
		background-color: #E8E8E8;
		border-radius: 50%;
		overflow: hidden;
	}

	.descContainer {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 5rem;
	}

	.labelItem {
		width: 100%;
		color: rgb(51, 51, 51);
		font-size: 20px;
	}

	.addressLabel {
		margin-top: 0.625rem;
		font-size: 0.75rem;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>